// @mui material components
import { Grid, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AsyncMultiDropdown from "layouts/TransactionsManagement/components/AsyncMultiDropdown";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Data
// import { columns, rows } from "components/PropertyListTable/data";
import { fundingSourceColumns } from "../../constants/columns.constants";
import { getPropertiesList } from "services/addProperty.service";

import useFundingSourceHook from "../../hooks/useFundingSourceHook";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 400,
    },
  },
};

const FundingSourceTable = () => {
  const {
    rows,
    isLoading,
    currentPage,
    setCurrentPage,
    isRemovalModal,
    isDeclineModal,
    closeRemovalModal,
    closeDeclineModal,
    removeFundingSource,
    declineFundingSourceRequest,
    isFundingSourceLoading,
    setPerPage,
    perPage,
    totalPage,
    totalCount,
  } = useFundingSourceHook();
  return (
    <MDBox pt={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info">
              <MDTypography variant="h6" color="white">
              Funding Source Remove Request
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                position: "relative",
                paddingTop: "85px",
                paddingBottom: {
                  xs: "150px",
                  sm: "95px",
                },
              }}>
              <DataTable
                table={{
                  columns: fundingSourceColumns,
                  rows: rows,
                }}
                canSearch={false}
                isSorted={true}
                entriesPerPage={true}
                showTotalEntries={true}
                isLoading={isLoading}
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPage={totalPage}
                totalRecords={totalCount}
                noEndBorder
              />
              {isRemovalModal && (
                <ConfirmModal
                  open={isRemovalModal}
                  onOkayClick={removeFundingSource}
                  onCloseModal={closeRemovalModal}
                  modalText={`Are you sure you want to Remove this funding source?`}
                  okayText={`Yes Sure`}
                  cancelText="No, cancel"
                  isLoading={isFundingSourceLoading}
                />
              )}
              {isDeclineModal && (
                <ConfirmModal
                  open={isDeclineModal}
                  onOkayClick={declineFundingSourceRequest}
                  onCloseModal={closeDeclineModal}
                  modalText={`Are you sure you want to decline this funding source request?`}
                  okayText={`Yes Sure`}
                  cancelText="No, cancel"
                  isLoading={isFundingSourceLoading}
                />
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default FundingSourceTable;
